/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTilaInfo_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null };

export type GetTilaInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_bankInfo_BankInfo = { readonly __typename: 'BankInfo', readonly accountNumberLastFour: string | null };

export type GetTilaInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo = { readonly __typename: 'CreditApplicationFinanceInfo', readonly bankInfo: GetTilaInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_bankInfo_BankInfo | null };

export type GetTilaInfo_creditApplication_CreditApplication_tila_SignableCreditApplicationDocument_meta_SignableCreditApplicationDocumentMeta = { readonly __typename: 'SignableCreditApplicationDocumentMeta', readonly signedAt: any | null, readonly underwritingDecisionUuid: string | null, readonly underwritingOfferType: _Types.UnderwritingOffer | null, readonly businessState: string | null };

export type GetTilaInfo_creditApplication_CreditApplication_tila_SignableCreditApplicationDocument = { readonly __typename: 'SignableCreditApplicationDocument', readonly type: _Types.SignableCreditApplicationDocumentType, readonly content: string, readonly meta: GetTilaInfo_creditApplication_CreditApplication_tila_SignableCreditApplicationDocument_meta_SignableCreditApplicationDocumentMeta };

export type GetTilaInfo_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly dsaVersion: string | null, readonly recordType: string | null, readonly authorizedSigner: GetTilaInfo_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null, readonly financeInfo: GetTilaInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo | null, readonly tila?: GetTilaInfo_creditApplication_CreditApplication_tila_SignableCreditApplicationDocument | null };

export type GetTilaInfo_Query = { readonly __typename: 'Query', readonly creditApplication: GetTilaInfo_creditApplication_CreditApplication | null };


export type GetTilaInfoVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
  underwritingOfferType?: _Types.InputMaybe<_Types.UnderwritingOffer>;
  underwritingDecisionUuid?: _Types.InputMaybe<_Types.Scalars['ID']['input']>;
  skipTila: _Types.Scalars['Boolean']['input'];
}>;


export type GetTilaInfo = GetTilaInfo_Query;


export const GetTilaInfoDocument = gql`
    query GetTilaInfo($creditApplicationId: ID!, $underwritingOfferType: UnderwritingOffer, $underwritingDecisionUuid: ID, $skipTila: Boolean!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    authorizedSigner {
      id
      email
    }
    dsaVersion
    recordType
    financeInfo {
      bankInfo {
        accountNumberLastFour
      }
    }
    tila(
      underwritingOfferType: $underwritingOfferType
      underwritingDecisionUuid: $underwritingDecisionUuid
    ) @skip(if: $skipTila) {
      type
      content
      meta {
        signedAt
        underwritingDecisionUuid
        underwritingOfferType
        businessState
      }
    }
  }
}
    `;

/**
 * __useGetTilaInfo__
 *
 * To run a query within a React component, call `useGetTilaInfo` and pass it any options that fit your needs.
 * When your component renders, `useGetTilaInfo` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTilaInfo({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      underwritingOfferType: // value for 'underwritingOfferType'
 *      underwritingDecisionUuid: // value for 'underwritingDecisionUuid'
 *      skipTila: // value for 'skipTila'
 *   },
 * });
 */
export function useGetTilaInfo(baseOptions: Apollo.QueryHookOptions<GetTilaInfo, GetTilaInfoVariables> & ({ variables: GetTilaInfoVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTilaInfo, GetTilaInfoVariables>(GetTilaInfoDocument, options);
      }
export function useGetTilaInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTilaInfo, GetTilaInfoVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTilaInfo, GetTilaInfoVariables>(GetTilaInfoDocument, options);
        }
export function useGetTilaInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTilaInfo, GetTilaInfoVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTilaInfo, GetTilaInfoVariables>(GetTilaInfoDocument, options);
        }
export type GetTilaInfoHookResult = ReturnType<typeof useGetTilaInfo>;
export type GetTilaInfoLazyQueryHookResult = ReturnType<typeof useGetTilaInfoLazyQuery>;
export type GetTilaInfoSuspenseQueryHookResult = ReturnType<typeof useGetTilaInfoSuspenseQuery>;
export type GetTilaInfoQueryResult = Apollo.QueryResult<GetTilaInfo, GetTilaInfoVariables>;